// extracted by mini-css-extract-plugin
export default {"profile":"eae401","profile__header":"f6bde9","profileHeader":"f6bde9","profile__desc":"a8823f","profileDesc":"a8823f","profile__button":"a038ed","profileButton":"a038ed"};